export default __webpack_public_path__ + "static/media/usa-hockey.9ab1b4cb.svg";